import { render, staticRenderFns } from "./ai-comment.vue?vue&type=template&id=417673c4&scoped=true&"
import script from "./ai-comment.vue?vue&type=script&lang=js&"
export * from "./ai-comment.vue?vue&type=script&lang=js&"
import style0 from "./ai-comment.vue?vue&type=style&index=0&id=417673c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417673c4",
  null
  
)

export default component.exports